import React from 'react';
import p from 'translation';
import { App } from 'core/types/app';
import theme from 'theme';

import icon from './icon.svg';

import { RoleId } from 'core/types/role';
import Icon from 'components/icon2';

const roles: RoleId[] = [
  'contentpackages:user',
  'contentpackages:manager',
  'organization:administrator',
];

export function hasMinimumContentpackagesRole(
  minimum: RoleId,
  role: RoleId,
): boolean {
  return roles.indexOf(minimum) <= roles.indexOf(role);
}

const contentpackages: App = {
  id: 'contentpackages',
  name: p.t('apps.contentpackages.name'),
  icon,
  color: theme.palette.contentpackages,
  app: React.lazy(() => import('./app')),
  navigation: [
    {
      title: p.t('apps.contentpackages.name'),
      path: '/',
      hasAccess: role =>
        hasMinimumContentpackagesRole('contentpackages:user', role),
      icon: <Icon icon='box-open' color={theme.palette.contentpackages.main} />,
      forceActive: (): boolean =>
        window.location.pathname.includes('/app/contentpackages'),
    },
  ],
};

export default contentpackages;
